import { ChangeEvent } from 'react';
import { EventOrValueHandler } from 'redux-form';

import ColorInput from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorStyleSections/inputs/ColorInput';
import { StyleLabel } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorStyleSections/inputs/StyleInput';

type ConnectedColorInputProps = {
  field: string;
  name: string;
  label?: string;
  value: string;
  editable?: boolean;
  onChange: (hex: string, field: string) => void;
};

const ColorStyleInput = ({
  field,
  name,
  label,
  value,
  editable = true,
  onChange,
}: ConnectedColorInputProps) => {
  const labelId = `${field}-${name}`;
  const inputId = `color-${labelId}-input`;

  return (
    <>
      {label && <StyleLabel htmlFor={inputId}>{label}</StyleLabel>}

      <ColorInput
        // TODO (Evan): pass in warning prop from call sites
        warning=''
        id={inputId}
        name={`color-${labelId}`}
        onChange={
          ((hex: string) => {
            onChange(hex, field);
          }) as EventOrValueHandler<ChangeEvent<string>>
        }
        placement='bottom-start'
        modifiers={[
          {
            name: 'offset',
            options: {
              // makes sure that the color picker is always left-aligned with the swatch
              offset: ({ placement }) => (placement === 'top-start' ? [-10, 220] : [-10, 32]),
            },
          },
          {
            // when there is not enough room to render the picker below the input,
            // flip to render above
            name: 'flip',
            options: {
              altBoundary: true,
              padding: { top: 0, bottom: 220, left: 0, right: 0 },
              fallbackPlacements: ['top-start'],
              allowedAutoPlacements: ['top-start', 'bottom-start'],
            },
          },
        ]}
        usePortal
        // Note (Evan): There always needs to be a color set, so we never show the
        // close button to clear. This overrides default behavior to set the field as undefined
        value={value}
        defaultValue={value}
        disabled={!editable}
        inputSize='sm'
      />
    </>
  );
};

export default ColorStyleInput;
